import {omit} from "lodash"
import {combineReducers} from "redux"
import dynamicConfiguration, * as fromDynConf from "../../shared-components/store/localStorage/dynamicConfiguration/dynamicConfigurationReducer"
import style, * as fromStyle from "../../shared-components/store/localStorage/style/styleReducer"
import texts, * as fromTexts from "../../shared-components/store/localStorage/texts/textsReducer"
import {CLEAR_LOCAL_STORAGE_VALUE, SAVE_LOCAL_STORAGE_VALUE} from "./localStorageActionTypes"

/**
 * Permet de sauvegarder des valeurs de façon générique
 */
const genericLocalStorage = (state = {}, action = {}) => {
    switch (action.type) {
        case SAVE_LOCAL_STORAGE_VALUE:
            return {
                ...state,
                [action.key]: action.value,
            }
        case CLEAR_LOCAL_STORAGE_VALUE:
            return omit(state, action.key)
        default:
            return state
    }
}

export const getLocalStorageValue = (state, key) => state.genericLocalStorage[key]

/**
 * Part of the store to stock data which will be saved in local storage.
 * Ici, pour éviter que le state sap et cesu s'écrase l'un l'autre, on utilise un nom de reducer différent
 */
const sap = combineReducers({
    genericLocalStorage,
    dynamicConfiguration,
    style,
    texts,
})

export default sap

// DYNAMIC CONFIGURATION OPERATIONS
/**
 * Return the value associated with the key if it is found in the state,
 * undefined otherwise.
 */
export const getDynamicConfigurationValue = (state, key) => fromDynConf.getValue(state.dynamicConfiguration, key)

// STYLE OPERATIONS
/**
 * Get the style from the store.
 */
export const getStyle = (state, contractId) => fromStyle.getStyle(state.style, contractId)
/**
 * Is style customized ?
 */
export const isCustomizedStyle = (state, contractId) => fromStyle.isCustomized(state.style, contractId)

// TEXTS OPERATIONS
/**
 * Get the texts from the store.
 */
export const getTexts = (state, contractId) => fromTexts.getTexts(state.texts, contractId)
/**
 * Are texts customized ?
 */
export const areCustomizedTexts = (state, contractId) => fromTexts.areCustomized(state.texts, contractId)
